'use strict';
; (function () {

    var selectResourcesModuleRoutes = [
        {
            "state": false,
            "name": "emrApptsInformationReportSelectResourcesPopup",
            "url": "emrApptsInformationReportSelectResourcesPopup",
            "RoutingNumber": 4651,
            templateUrl: "AngularScripts/SelectResources/Htmls/SelectResources.html",
            files: [
                "AngularScripts/SelectResources/Services/SelectResourcesService.js",
                "AngularScripts/EhrAgGridHandler/Factories/EhrAgGridHandlerFactory.js",
                "AngularScripts/SelectResources/Controllers/SelectResourcesController.js",
            ]
        },

    ]

    angular.module('EMR.SelectResourcesModule',[])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(selectResourcesModuleRoutes, $stateProvider);
            }]);
})();
